var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_5318)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21 23.6094H3C2.59 23.6094 2.25 23.2694 2.25 22.8594C2.25 22.4494 2.59 22.1094 3 22.1094H21C21.41 22.1094 21.75 22.4494 21.75 22.8594C21.75 23.2694 21.41 23.6094 21 23.6094Z",
    fill: "#392C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59998 9.24023H4C3.45 9.24023 3 9.69023 3 10.2402V18.8602C3 19.4102 3.45 19.8602 4 19.8602H5.59998C6.14998 19.8602 6.59998 19.4102 6.59998 18.8602V10.2402C6.59998 9.68023 6.14998 9.24023 5.59998 9.24023Z",
    fill: "#392C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7992 6.04883H11.1992C10.6492 6.04883 10.1992 6.49883 10.1992 7.04883V18.8588C10.1992 19.4088 10.6492 19.8588 11.1992 19.8588H12.7992C13.3492 19.8588 13.7992 19.4088 13.7992 18.8588V7.04883C13.7992 6.49883 13.3492 6.04883 12.7992 6.04883Z",
    fill: "#392C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0023 2.85938H18.4023C17.8523 2.85938 17.4023 3.30937 17.4023 3.85938V18.8594C17.4023 19.4094 17.8523 19.8594 18.4023 19.8594H20.0023C20.5523 19.8594 21.0023 19.4094 21.0023 18.8594V3.85938C21.0023 3.30937 20.5523 2.85938 20.0023 2.85938Z",
    fill: "#392C7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_5318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.859375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5);
export default __webpack_public_path__ + "static/media/img5.0527f584872506f5e968f4d01bdcb670.svg";
export { ForwardRef as ReactComponent };